(function () {
    'use strict';

    angular
        .module('externalPartyEditModule')
        .controller('ODDCampaignQuestionnaireSectionAddController', Controller);

    Controller.$inject = ['$scope', '$state', 'oddCampaignService', 'oddQuestionnaireTemplateService'];

    function Controller($scope, $state, oddCampaignService, oddQuestionnaireTemplateService) {

        // Get Questionnaire Template
        oddQuestionnaireTemplateService.getQuestionnaire($scope.campaign.ODDBusinessUnitID, $scope.questionnaire.ODDQuestionnaireID).then(function (qTemplate) {
            $scope.sections = _.differenceBy(qTemplate.ODDSections, $scope.questionnaire.ODDCampaignSections, 'ODDSectionID');
        });

        $scope.addSection = function (section) {
            var sectionToCreate = {
                ODDSectionID: section.ODDSectionID
            };

            oddCampaignService.createSection($scope.campaign.ODDBusinessUnitID, $scope.campaign.ODDExternalPartyID,
                    $scope.campaign.ODDCampaignID, $scope.questionnaire.ODDCampaignQuestionnaireID, sectionToCreate).then(function () {
                $scope.$hide();
                $state.reload();
            });
        }
    }
})();